module.exports = __webpack_public_path__ + "static/media/envoroment.33652765.png";